// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* :root variables moved to index.css for global theme management */

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Plus Jakarta Sans', sans-serif;
  line-height: 1.6;
  color: var(--text-main);
  background-color: var(--background);
  overflow-x: hidden;
}

.landing-page {
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  background: var(--background);
}

/* Hyperspeed Background */
.hyperspeed-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 0;
}

.hyperspeed-bg.light-mode-bg {
  /* Removed opacity and blur so colors render fully */
}

/* Navbar */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background: var(--header-bg);
  backdrop-filter: var(--glass-blur);
  border-bottom: var(--glass-border);
  box-shadow: var(--glass-shadow);
  transition: all 0.4s ease;
}

.navbar:hover {
  background: var(--navbar-bg);
}

.nav-brand {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-family: 'Outfit', sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-main);
  text-decoration: none;
  letter-spacing: -0.02em;
}

.brand-icon {
  height: 30px;
  width: auto;
  /* mix-blend-mode: screen; Optional: helps if logo has black bg */
}

.btn-primary-small {
  padding: 0.6rem 1.25rem;
  background: var(--gradient-main);
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
  position: relative;
  overflow: hidden;
}

.btn-primary-small:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(99, 102, 241, 0.5);
}

.btn-outline {
  /* Deprecated in new design but kept for reference if needed */
  padding: 0.75rem 1.75rem;
  background: transparent;
  color: var(--text-main);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(5px);
}

/* Hero Section */
.hero-section {
  padding: 130px 5% 60px;
  position: relative;
  z-index: 1;
}

.hero-content {
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 40% 60%;
  gap: 2.5rem;
  align-items: flex-start;
}

.hero-visual {
  width: 100%;
  min-width: 0;
}

.hero-text {
  text-align: left;
  min-width: 0;
}

.hero-title {
  font-family: 'Outfit', sans-serif;
  font-size: 4rem;
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 1.5rem;
  letter-spacing: -0.03em;
}

.gradient-text {
  background: var(--gradient-main);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: inline-block;
  padding-bottom: 10px;
  /* Prevent descender clipping */
}

.hero-subtitle {
  font-size: 1.25rem;
  color: var(--text-muted);
  margin-bottom: 3rem;
  line-height: 1.7;
  max-width: 90%;
  font-weight: 400;
}

.hero-checklist {
  display: flex;
  flex-wrap: nowrap;
  gap: 1rem;
  margin-bottom: 3.5rem;
  align-items: center;
}

@media (max-width: 1200px) {
  .hero-checklist {
    flex-wrap: wrap;
    gap: 1.25rem;
  }
}

.checklist-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: 'Outfit', sans-serif;
  font-size: 0.92rem;
  font-weight: 600;
  color: var(--text-main);
  opacity: 0.85;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.checklist-item:hover {
  opacity: 1;
  transform: translateY(-1px);
}

.checklist-icon {
  color: #d946ef; /* Magenta/Purple check icon color from screenshot */
  flex-shrink: 0;
  filter: drop-shadow(0 0 5px rgba(217, 70, 239, 0.45));
}

.hero-actions {
  display: flex;
  gap: 1.5rem;
  margin-top: 1rem;
}

.btn-primary-large {
  position: relative;
  padding: 1.25rem 3rem;
  background: var(--gradient-main);
  color: white;
  border: none;
  border-radius: 16px;
  font-size: 1.125rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 0 20px rgba(99, 102, 241, 0.4);
  overflow: hidden;
  z-index: 1;
}

.btn-primary-large::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.3), transparent);
  transform: translateX(-100%);
  transition: transform 0.6s ease;
  z-index: -1;
}

.btn-primary-large:hover {
  transform: translateY(-4px) scale(1.02);
  box-shadow: 0 0 40px rgba(168, 85, 247, 0.6);
}

.btn-primary-large:hover::before {
  transform: translateX(100%);
}

/* Target Platforms Panel */
.target-platforms-panel {
  background: rgba(10, 14, 35, 0.6);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border-radius: 24px;
  border: 1.5px solid rgba(99, 102, 241, 0.25);
  box-shadow:
    0 40px 80px -20px rgba(0, 0, 0, 0.7),
    0 0 40px rgba(99, 102, 241, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.06);
  padding: 1.75rem;
  transform: rotateY(-8deg) rotateX(4deg);
  transform-style: preserve-3d;
  transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.6s ease;
  position: relative;
  overflow: hidden;
}

.target-platforms-panel::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(168, 85, 247, 0.4), transparent);
}

.target-platforms-panel:hover {
  transform: rotateY(0deg) rotateX(0deg) scale(1.02);
  box-shadow:
    0 50px 100px -20px rgba(0, 0, 0, 0.8),
    0 0 60px rgba(168, 85, 247, 0.18),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

.tp-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.tp-title {
  font-family: 'Outfit', sans-serif;
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text-main);
  letter-spacing: 0.01em;
}

.tp-live-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  background: rgba(16, 185, 129, 0.12);
  border: 1px solid rgba(16, 185, 129, 0.25);
  border-radius: 20px;
  font-size: 0.7rem;
  font-weight: 700;
  color: #34d399;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.tp-live-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #34d399;
  box-shadow: 0 0 6px #34d399;
  animation: tpLivePulse 2s ease infinite;
}

@keyframes tpLivePulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50%       { opacity: 0.5; transform: scale(0.8); }
}

.tp-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.tp-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.85rem 1rem;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 14px;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  cursor: default;
  position: relative;
  overflow: hidden;
}

.tp-item::before {
  content: '';
  position: absolute;
  left: 0; top: 0; bottom: 0;
  width: 3px;
  border-radius: 3px 0 0 3px;
  background: var(--gradient-main);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.tp-item:hover {
  background: rgba(99, 102, 241, 0.07);
  border-color: rgba(99, 102, 241, 0.2);
  transform: translateX(4px);
}

.tp-item:hover::before {
  opacity: 1;
}

.tp-item--soon {
  opacity: 0.55;
}

.tp-item--soon:hover {
  opacity: 0.75;
}

.tp-item-icon {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.07);
  flex-shrink: 0;
}

.tp-item-icon--plain {
  background: rgba(99, 102, 241, 0.08);
  border-color: rgba(99, 102, 241, 0.15);
}

.tp-logo {
  width: 26px;
  height: 26px;
  object-fit: contain;
}

.aws-logo-theme-fix {
  filter: invert(1) hue-rotate(180deg) brightness(1.3) opacity(0.85);
}

.tp-item-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1;
  min-width: 0;
}

.tp-item-name {
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--text-main);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tp-item-tag {
  font-size: 0.7rem;
  font-weight: 500;
  color: var(--text-muted);
  letter-spacing: 0.3px;
}

.tp-item-status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.3px;
  flex-shrink: 0;
  text-transform: uppercase;
}

.tp-status--active {
  background: rgba(16, 185, 129, 0.12);
  border: 1px solid rgba(16, 185, 129, 0.22);
  color: #34d399;
}

.tp-status--active .tp-status-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #34d399;
  box-shadow: 0 0 5px #34d399;
  animation: tpLivePulse 2s ease infinite;
}

.tp-status--soon {
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.2);
  color: #f59e0b;
}

.tp-status--soon .tp-status-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #f59e0b;
}

.tp-footer {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.tp-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.tp-stat-val {
  font-family: 'Outfit', sans-serif;
  font-size: 1.1rem;
  font-weight: 800;
  background: var(--gradient-main);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.tp-stat-label {
  font-size: 0.65rem;
  color: var(--text-muted);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.tp-stat-divider {
  width: 1px;
  height: 28px;
  background: rgba(255, 255, 255, 0.07);
}

/* Dashboard Preview (3D Effect) */
.hero-visual {
  perspective: 2000px;
  z-index: 2;
}

.dashboard-preview {
  background: rgba(15, 22, 42, 0.4) !important;
  backdrop-filter: var(--glass-blur);
  border-radius: 24px;
  border: 1.5px solid rgba(99, 102, 241, 0.25) !important;
  box-shadow:
    0 50px 100px -20px rgba(0, 0, 0, 0.8),
    0 0 40px rgba(99, 102, 241, 0.15),
    var(--glass-inner-glow);
  padding: 2rem;
  transform-style: preserve-3d;
  transform: rotateY(-12deg) rotateX(6deg);
  transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.6s ease;
  position: relative;
}

.dashboard-preview:hover {
  transform: rotateY(0deg) rotateX(0deg) scale(1.02);
  box-shadow:
    0 60px 120px -20px rgba(0, 0, 0, 0.85),
    0 0 60px rgba(168, 85, 247, 0.2),
    var(--glass-inner-glow);
}

/* Glass Details inside Dashboard */
.preview-header {
  display: flex;
  margin-bottom: 2rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  padding-bottom: 1.5rem;
}

.preview-tabs {
  display: flex;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.03);
  padding: 0.5rem;
  border-radius: 12px;
}

.tab {
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--text-muted);
  cursor: pointer;
  transition: all 0.3s ease;
}

.tab.active {
  background: var(--surface-light);
  color: var(--text-main);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.preview-content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.preview-card {
  display: flex;
  align-items: center;
  gap: 1.25rem;
  padding: 1.25rem;
  background: rgba(255, 255, 255, 0.03) !important;
  border: var(--glass-border) !important;
  border-radius: 16px;
  box-shadow: var(--glass-inner-glow);
}

.card-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(99, 102, 241, 0.1);
  border-radius: 12px;
  font-size: 1.5rem;
}

.card-info h4 {
  font-family: 'Outfit', sans-serif;
  color: var(--text-main);
  margin-bottom: 0.25rem;
}

.card-status {
  margin-left: auto;
  padding: 0.4rem 1rem;
  background: rgba(16, 185, 129, 0.2);
  color: #34d399;
  border: 1px solid rgba(16, 185, 129, 0.2);
  border-radius: 30px;
  font-size: 0.8rem;
  font-weight: 600;
}

.migration-progress {
  padding: 1.5rem;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.1) 0%, rgba(168, 85, 247, 0.1) 100%);
  border: 1px solid rgba(99, 102, 241, 0.2);
  border-radius: 16px;
}

.progress-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  font-weight: 600;
  color: var(--text-main);
}

.progress-bar {
  height: 8px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: var(--gradient-main);
  border-radius: 4px;
  filter: drop-shadow(0 0 8px rgba(168, 85, 247, 0.5));
}

/* CTA Section */
.cta-section {
  padding: 120px 5%;
  text-align: center;
  position: relative;
  z-index: 1;
  background: linear-gradient(to bottom, transparent, rgba(99, 102, 241, 0.05));
}

.cta-section h2 {
  font-size: 3rem;
  font-family: 'Outfit', sans-serif;
  margin-bottom: 3rem;
  background: var(--gradient-heading);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* Footer */
.footer {
  padding: 50px 140px 30px; /* Reduced vertical padding from 80px/40px to 50px/30px */
  background: rgba(2, 6, 23, 0.75); /* Dark solid-glass overlay to shield the text */
  backdrop-filter: blur(20px); /* Deep blur to soften background light trails */
  -webkit-backdrop-filter: blur(20px);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  position: relative;
  z-index: 10; /* Ensure it stays on top of the animation canvas */
}

.footer-content {
  display: grid;
  grid-template-columns: 1fr auto 1fr; /* Symmetrical 3-column grid */
  align-items: center;
  max-width: 1200px;
  margin: 0 auto 1.5rem; /* Reduced bottom margin from 3rem to 1.5rem */
  gap: 0;
}

.footer-left {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  padding-right: 3rem; /* Space before divider */
}

.footer-desc {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.5;
  margin: 0;
  max-width: 380px;
  text-align: left;
}

.footer-divider {
  width: 1px;
  height: 60px;
  background: rgba(255, 255, 255, 0.1);
  align-self: center;
}

.footer-right {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.3rem;
  padding-left: 3rem; /* Space after divider */
}

.footer-title {
  font-size: 0.85rem;
  font-weight: 700;
  color: #f59e0b;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.footer-link-text {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  text-align: left;
  line-height: 1.5;
}

.footer-link-text a {
  color: #f59e0b;
  text-decoration: none;
  font-weight: 600;
  transition: opacity 0.2s;
}

.footer-link-text a:hover {
  opacity: 0.8;
}

.footer-bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 1.25rem; /* Reduced padding-top from 2rem to 1.25rem */
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.4);
  font-size: 0.9rem;
  gap: 0.85rem; /* Reduced gap from 1.25rem to 0.85rem */
}

.footer-copyright {
  text-align: center;
  margin: 0;
  white-space: nowrap; /* Keep it on a single line on desktop */
}

.scroll-to-top-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid rgba(59, 130, 246, 0.3); /* Blueish border */
  background: rgba(13, 35, 73, 0.4); /* Dark blueish glassy background */
  backdrop-filter: blur(8px); /* Glassy blur */
  -webkit-backdrop-filter: blur(8px);
  color: #60a5fa; /* Light blue arrow */
  cursor: pointer;
  font-size: 1.25rem;
  line-height: 1;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  outline: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), inset 0 1px 1px rgba(255, 255, 255, 0.1);
}

.scroll-to-top-btn:hover {
  border-color: rgba(59, 130, 246, 0.6);
  color: #fff;
  background: rgba(59, 130, 246, 0.25); /* Vibrant blue glass hover */
  box-shadow: 0 0 15px rgba(59, 130, 246, 0.4), inset 0 1px 1px rgba(255, 255, 255, 0.2);
  transform: translateY(-3px); /* Subtle lift */
}

/* Responsive */
@media (max-width: 1024px) {
  .hero-content {
    grid-template-columns: 1fr;
    text-align: center;
    gap: 4rem;
  }

  .hero-text {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .dashboard-preview {
    transform: none;
    /* Disable 3D tilt on tablet/mobile for readability */
  }

  .dashboard-preview:hover {
    transform: scale(1.02);
  }
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 3rem;
  }

  .hero-checklist {
    gap: 1.25rem;
    justify-content: flex-start;
  }

  .footer-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2rem;
  }

  .footer-left {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
    width: 100%;
    padding-right: 0; /* Reset desktop padding */
  }

  .footer-desc {
    max-width: 100%;
  }

  .footer-divider {
    display: none;
  }

  .footer-right {
    padding-left: 0; /* Reset desktop padding */
    border-left: none;
    width: 100%;
  }

  .footer-bottom {
    display: flex;
    flex-direction: column-reverse;
    gap: 1.5rem;
    align-items: center;
    text-align: center;
    width: 100%;
  }

  .footer-bottom-spacer {
    display: none;
  }

  .footer-copyright {
    text-align: center;
    width: 100%;
    white-space: normal; /* Allow text wrap on mobile */
  }

  .footer-scroll-wrapper {
    justify-content: center;
    width: 100%;
  }

  .footer-link-text {
    white-space: normal; /* Allow wrap on mobile */
  }
}

/* ──────────────────────────────────────
   NEW SAAS LANDING PAGE BODY SECTIONS
   ────────────────────────────────────── */

.landing-section {
  padding: 110px 5%;
  position: relative;
  z-index: 1;
  max-width: 1300px;
  margin: 0 auto;
}

.badge-pill-feature {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  background: rgba(168, 85, 247, 0.08);
  border: 1px solid rgba(168, 85, 247, 0.22);
  border-radius: 30px;
  color: #c084fc;
  font-family: 'Outfit', sans-serif;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  margin-bottom: 20px;
}

.section-header-left {
  text-align: left;
  margin-bottom: 60px;
  max-width: 800px;
}

.section-header-center {
  text-align: center;
  margin-bottom: 60px;
  max-width: 750px;
  margin-left: auto;
  margin-right: auto;
}

.section-main-title {
  font-family: 'Outfit', sans-serif;
  font-size: 2.75rem;
  font-weight: 800;
  color: var(--text-main);
  line-height: 1.15;
  letter-spacing: -0.02em;
}

.section-sub-desc {
  color: var(--text-muted);
  font-size: 1.125rem;
  line-height: 1.6;
  margin-top: 15px;
}

.db-preview-panel {
  background: rgba(5, 8, 26, 0.92);
  border: 1px solid rgba(99, 102, 241, 0.25);
  border-radius: 20px;
  padding: 1.6rem 1.8rem;
  backdrop-filter: blur(20px);
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  box-shadow: 0 8px 40px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.06);
}

.db-preview-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.8rem;
}

.db-preview-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: 'Outfit', sans-serif;
  font-size: 0.92rem;
  font-weight: 700;
  color: rgba(255,255,255,0.92);
}

.db-live-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #34d399;
  box-shadow: 0 0 8px #34d399;
  animation: db-pulse 1.5s ease-in-out infinite;
  flex-shrink: 0;
}

@keyframes db-pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.55; transform: scale(0.85); }
}

.db-preview-badge {
  font-family: 'Outfit', sans-serif;
  font-size: 0.68rem;
  font-weight: 600;
  color: rgba(168,85,247,0.85);
  background: rgba(168,85,247,0.1);
  border: 1px solid rgba(168,85,247,0.25);
  border-radius: 20px;
  padding: 0.22rem 0.65rem;
  white-space: nowrap;
}

.db-section {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.db-label {
  font-family: 'Outfit', sans-serif;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.35);
}

.db-progress-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.db-progress-pct {
  font-family: 'Outfit', sans-serif;
  font-size: 0.88rem;
  font-weight: 700;
  color: #a78bfa;
}

.db-progress-track {
  height: 7px;
  background: rgba(255,255,255,0.07);
  border-radius: 6px;
  overflow: hidden;
}

.db-progress-fill {
  height: 100%;
  border-radius: 6px;
  background: linear-gradient(90deg, #7c3aed, #a855f7, #c084fc);
  box-shadow: 0 0 10px rgba(168,85,247,0.5);
  transition: width 0.15s linear;
}

.db-progress-sub {
  display: flex;
  justify-content: space-between;
  font-family: 'Outfit', sans-serif;
  font-size: 0.68rem;
  color: rgba(255,255,255,0.35);
  margin-top: 0.15rem;
}

.db-stats-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.7rem;
}

.db-stat-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 10px;
  padding: 0.6rem 0.4rem;
  text-align: center;
}

.db-stat-value {
  font-family: 'Outfit', sans-serif;
  font-size: 0.88rem;
  font-weight: 800;
  line-height: 1;
  letter-spacing: -0.01em;
}

.db-stat-label {
  font-family: 'Outfit', sans-serif;
  font-size: 0.62rem;
  font-weight: 500;
  color: rgba(255,255,255,0.35);
  text-align: center;
}

.db-chart-container {
  width: 100%;
  height: 80px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  overflow: hidden;
  margin-top: 0.2rem;
}

.db-preview-footer {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: 'Outfit', sans-serif;
  font-size: 0.7rem;
  color: rgba(255,255,255,0.3);
  border-top: 1px solid rgba(255,255,255,0.06);
  padding-top: 0.8rem;
  margin-top: 0.2rem;
}

.db-footer-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
  animation: db-pulse 1.5s ease-in-out infinite;
}


/* Compare Grid Section */
.compare-section-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2.5rem;
}


.compare-card {
  position: relative;
  height: 285px;
  padding: 2.2rem;
  background: var(--card-bg);
  border: var(--glass-border);
  border-radius: 24px;
  backdrop-filter: var(--glass-blur);
  box-shadow: var(--glass-shadow);
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.compare-card.large-card {
  grid-column: span 2;
}

.compare-card:hover {
  background: rgba(20, 24, 48, 0.65);
  transform: translateY(-6px);
  border-color: rgba(168, 85, 247, 0.45);
  box-shadow: 0 0 35px rgba(168, 85, 247, 0.2),
              inset 0 0 18px rgba(168, 85, 247, 0.15),
              var(--glass-shadow);
}

.compare-card .compare-card-top {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  opacity: 1;
  transform: scale(1);
  transition: opacity 0.4s cubic-bezier(0.16, 1, 0.3, 1),
              transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.compare-card:hover .compare-card-top {
  opacity: 0;
  transform: scale(0.96);
  pointer-events: none;
}

.compare-card .icon-wrap {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(168, 85, 247, 0.12);
  color: #a855f7;
}

.compare-card h3 {
  font-family: 'Outfit', sans-serif;
  font-size: 1.35rem;
  font-weight: 700;
  color: var(--text-main);
  letter-spacing: -0.01em;
}

.compare-card p {
  font-size: 0.95rem;
  color: var(--text-muted);
  line-height: 1.6;
}

.large-card-banner {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  width: auto;
  height: auto;
  opacity: 0;
  transform: scale(0.96);
  pointer-events: none;
  background: rgba(15, 23, 42, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.05), 0 8px 32px rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  transition: opacity 0.4s cubic-bezier(0.16, 1, 0.3, 1),
              transform 0.4s cubic-bezier(0.16, 1, 0.3, 1),
              border-color 0.4s ease;
}

.card-diagram-banner {
  position: absolute;
  top: 1.8rem;
  left: 1.8rem;
  right: 1.8rem;
  bottom: 1.8rem;
  margin: 0;
  width: auto;
  height: auto;
  opacity: 0;
  transform: scale(0.96);
  pointer-events: none;
  background: rgba(15, 23, 42, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.05), 0 8px 32px rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  transition: opacity 0.4s cubic-bezier(0.16, 1, 0.3, 1),
              transform 0.4s cubic-bezier(0.16, 1, 0.3, 1),
              border-color 0.4s ease;
}

.compare-card:hover .large-card-banner,
.compare-card:hover .card-diagram-banner {
  opacity: 1;
  transform: scale(1);
  pointer-events: auto;
  border-color: rgba(255, 255, 255, 0.1);
}

/* Split Layout Section */
.split-layout-section {
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 4rem;
  align-items: center;
}

.split-left-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.split-left-content .section-main-title {
  margin-top: 10px;
  margin-bottom: 20px;
}

.split-left-content p {
  color: var(--text-muted);
  font-size: 1.1rem;
  line-height: 1.65;
  margin-bottom: 30px;
}

.mini-cards-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.25rem;
  margin-bottom: 2rem;
  width: 100%;
}

.mini-card {
  padding: 0.8rem 1rem;
  background: var(--card-bg);
  border: var(--glass-border);
  border-radius: 16px;
  backdrop-filter: var(--glass-blur);
  box-shadow: var(--glass-shadow);
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.mini-card .border-glow-inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
}

.mini-card:hover {
  border-color: rgba(99, 102, 241, 0.3);
  transform: translateY(-2px);
}

.mini-card .mini-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(99, 102, 241, 0.15);
  color: #6366f1;
}

.mini-card span {
  font-weight: 700;
  font-size: 0.9rem;
  color: var(--text-main);
  letter-spacing: -0.1px;
}

/* Status list card */
.status-list-card {
  padding: 1.5rem;
  background: var(--card-bg);
  border: var(--glass-border);
  border-radius: 20px;
  backdrop-filter: var(--glass-blur);
  box-shadow: var(--glass-shadow);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
}

.status-list-title {
  font-size: 0.775rem;
  font-weight: 700;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 1px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  padding-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.status-list-title .live-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #10b981;
  box-shadow: 0 0 8px #10b981;
  animation: livePulse 2s infinite;
}

@keyframes livePulse {
  0%, 100% { opacity: 0.3; }
  50% { opacity: 1; }
}

.status-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.03);
}

.status-item:last-child {
  border-bottom: none;
}

.status-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.status-db-info {
  display: flex;
  flex-direction: column;
}

.status-db-name {
  font-weight: 700;
  font-size: 0.9rem;
  color: var(--text-main);
}

.status-route {
  font-size: 0.75rem;
  color: var(--text-muted);
  margin-top: 2px;
}

.status-right {
  display: flex;
  align-items: center;
  gap: 15px;
}

.status-badge {
  font-size: 0.7rem;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 10px;
}

.status-badge.active {
  color: #10b981;
  background: rgba(16, 185, 129, 0.1);
  border: 1px solid rgba(16, 185, 129, 0.2);
}

.status-badge.soon {
  color: #a855f7;
  background: rgba(168, 85, 247, 0.1);
  border: 1px solid rgba(168, 85, 247, 0.2);
}

.status-perf {
  font-size: 0.8rem;
  color: #22d3ee;
  font-weight: 600;
  font-family: monospace;
}

/* Timeline workflow */
.timeline-container {
  max-width: 850px;
  margin: 0 auto;
  position: relative;
  padding-left: 45px;
}

.timeline-line {
  position: absolute;
  left: 15px;
  top: 20px;
  bottom: 20px;
  width: 2px;
  background: linear-gradient(to bottom, #7c3aed 0%, #3b82f6 50%, #06b6d4 100%);
  opacity: 0.35;
}

.timeline-item {
  position: relative;
  margin-bottom: 3rem;
}

.timeline-item:last-child {
  margin-bottom: 0;
}

.timeline-dot {
  position: absolute;
  left: -45px;
  top: 12px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #07091e;
  border: 2px solid #7c3aed;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 15px rgba(124, 58, 237, 0.4);
  z-index: 2;
  transition: all 0.3s ease;
  color: #a855f7;
}

.timeline-item:hover .timeline-dot {
  background: #7c3aed;
  color: white !important;
  transform: scale(1.1);
}

.timeline-card {
  padding: 2rem 2.25rem;
  background: var(--card-bg);
  border: var(--glass-border);
  border-radius: 20px;
  backdrop-filter: var(--glass-blur);
  box-shadow: var(--glass-shadow);
  display: flex;
  flex-direction: column;
  gap: 8px;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.timeline-card:hover {
  border-color: rgba(99, 102, 241, 0.3);
  box-shadow: 0 10px 30px rgba(99, 102, 241, 0.05), var(--glass-shadow);
}

.timeline-step-badge {
  align-self: flex-start;
  font-size: 0.725rem;
  font-weight: 700;
  color: #a855f7;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  margin-bottom: 4px;
}

.timeline-card h3 {
  font-family: 'Outfit', sans-serif;
  font-size: 1.35rem;
  font-weight: 700;
  color: var(--text-main);
  letter-spacing: -0.01em;
}

.timeline-card p {
  font-size: 0.95rem;
  color: var(--text-muted);
  line-height: 1.65;
}

/* Responsive adjustment for split layouts */
@media (max-width: 1024px) {
  .compare-section-grid {
    grid-template-columns: 1fr;
  }
  .compare-card.large-card {
    grid-row: span 1;
  }
  .split-layout-section {
    grid-template-columns: 1fr;
    gap: 3rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/LandingPage.css"],"names":[],"mappings":"AAEA,mEAAmE;;AAEnE;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,oDAAoD;AACtD;;AAEA,WAAW;AACX;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,kCAAkC;EAClC,kCAAkC;EAClC,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iEAAiE;AACnE;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iDAAiD;EACjD,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,8DAA8D;EAC9D,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iDAAiD;EACjD,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,cAAc,EAAE,oDAAoD;EACpE,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,4CAA4C;EAC5C,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yFAAyF;EACzF,4BAA4B;EAC5B,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,4CAA4C;EAC5C;;;2CAGyC;EACzC,gBAAgB;EAChB,uCAAuC;EACvC,4BAA4B;EAC5B,8EAA8E;EAC9E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ;EACzB,WAAW;EACX,qFAAqF;AACvF;;AAEA;EACE,kDAAkD;EAClD;;;0CAGwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,WAAW,UAAU,EAAE,mBAAmB,EAAE;EAC5C,YAAY,YAAY,EAAE,qBAAqB,EAAE;AACnD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,kDAAkD;EAClD,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO,EAAE,MAAM,EAAE,SAAS;EAC1B,UAAU;EACV,0BAA0B;EAC1B,gCAAgC;EAChC,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;EACnB,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qCAAqC;AACvC;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,4CAA4C;EAC5C,kCAAkC;EAClC,mBAAmB;EACnB,uDAAuD;EACvD;;;2BAGyB;EACzB,aAAa;EACb,4BAA4B;EAC5B,wCAAwC;EACxC,8EAA8E;EAC9E,kBAAkB;AACpB;;AAEA;EACE,kDAAkD;EAClD;;;2BAGyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,kDAAkD;EAClD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gDAAgD;EAChD,sCAAsC;EACtC,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mCAAmC;EACnC,cAAc;EACd,yCAAyC;EACzC,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,6FAA6F;EAC7F,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,oDAAoD;AACtD;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,6EAA6E;AAC/E;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,mBAAmB;EACnB,mCAAmC;EACnC,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,WAAW;AACX;EACE,wBAAwB,EAAE,yDAAyD;EACnF,gCAAgC,EAAE,gDAAgD;EAClF,2BAA2B,EAAE,gDAAgD;EAC7E,mCAAmC;EACnC,+CAA+C;EAC/C,kBAAkB;EAClB,WAAW,EAAE,mDAAmD;AAClE;;AAEA;EACE,aAAa;EACb,mCAAmC,EAAE,8BAA8B;EACnE,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB,EAAE,8CAA8C;EACrE,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB,EAAE,yBAAyB;AAChD;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,kBAAkB,EAAE,wBAAwB;AAC9C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,oBAAoB,EAAE,6CAA6C;EACnE,+CAA+C;EAC/C,+BAA+B;EAC/B,iBAAiB;EACjB,YAAY,EAAE,wCAAwC;AACxD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,mBAAmB,EAAE,wCAAwC;AAC/D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC,EAAE,mBAAmB;EAC9D,iCAAiC,EAAE,mCAAmC;EACtE,0BAA0B,EAAE,gBAAgB;EAC5C,kCAAkC;EAClC,cAAc,EAAE,qBAAqB;EACrC,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,iDAAiD;EACjD,aAAa;EACb,oFAAoF;AACtF;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,oCAAoC,EAAE,6BAA6B;EACnE,sFAAsF;EACtF,2BAA2B,EAAE,gBAAgB;AAC/C;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,qDAAqD;EACvD;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,gBAAgB,EAAE,0BAA0B;EAC9C;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe,EAAE,0BAA0B;IAC3C,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB,EAAE,8BAA8B;EACrD;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,mBAAmB,EAAE,yBAAyB;EAChD;AACF;;AAEA;;2CAE2C;;AAE3C;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,0CAA0C;EAC1C,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,WAAW,UAAU,EAAE,mBAAmB,EAAE;EAC5C,MAAM,aAAa,EAAE,sBAAsB,EAAE;AAC/C;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,gCAAgC;EAChC,uCAAuC;EACvC,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iCAAiC;EACjC,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iCAAiC;EACjC,iBAAiB;EACjB,4BAA4B;EAC5B,4CAA4C;EAC5C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,6CAA6C;AAC/C;;;AAGA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;EACnB,kCAAkC;EAClC,+BAA+B;EAC/B,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,sCAAsC;EACtC;;iCAE+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB;0DACwD;AAC1D;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,oBAAoB;EACpB,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,oFAAoF;EACpF,2BAA2B;EAC3B,mCAAmC;EACnC;;oCAEkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;EACd,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,oBAAoB;EACpB,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,oFAAoF;EACpF,2BAA2B;EAC3B,mCAAmC;EACnC;;oCAEkC;AACpC;;AAEA;;EAEE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;EACnB,kCAAkC;EAClC,+BAA+B;EAC/B,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;EACnB,kCAAkC;EAClC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,kDAAkD;EAClD,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,UAAU,EAAE;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,UAAU;EACV,6EAA6E;EAC7E,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,UAAU;EACV,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;EACnB,kCAAkC;EAClC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kDAAkD;AACpD;;AAEA;EACE,qCAAqC;EACrC,qEAAqE;AACvE;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA,4CAA4C;AAC5C;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');\r\n\r\n/* :root variables moved to index.css for global theme management */\r\n\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  font-family: 'Plus Jakarta Sans', sans-serif;\r\n  line-height: 1.6;\r\n  color: var(--text-main);\r\n  background-color: var(--background);\r\n  overflow-x: hidden;\r\n}\r\n\r\n.landing-page {\r\n  min-height: 100vh;\r\n  position: relative;\r\n  overflow: hidden;\r\n  background: var(--background);\r\n}\r\n\r\n/* Hyperspeed Background */\r\n.hyperspeed-bg {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100vh;\r\n  z-index: 0;\r\n}\r\n\r\n.hyperspeed-bg.light-mode-bg {\r\n  /* Removed opacity and blur so colors render fully */\r\n}\r\n\r\n/* Navbar */\r\n.navbar {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  z-index: 1000;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 1rem 2rem;\r\n  background: var(--header-bg);\r\n  backdrop-filter: var(--glass-blur);\r\n  border-bottom: var(--glass-border);\r\n  box-shadow: var(--glass-shadow);\r\n  transition: all 0.4s ease;\r\n}\r\n\r\n.navbar:hover {\r\n  background: var(--navbar-bg);\r\n}\r\n\r\n.nav-brand {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  font-family: 'Outfit', sans-serif;\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  color: var(--text-main);\r\n  text-decoration: none;\r\n  letter-spacing: -0.02em;\r\n}\r\n\r\n.brand-icon {\r\n  height: 30px;\r\n  width: auto;\r\n  /* mix-blend-mode: screen; Optional: helps if logo has black bg */\r\n}\r\n\r\n.btn-primary-small {\r\n  padding: 0.6rem 1.25rem;\r\n  background: var(--gradient-main);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  font-size: 0.9rem;\r\n  cursor: pointer;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.btn-primary-small:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 8px 20px rgba(99, 102, 241, 0.5);\r\n}\r\n\r\n.btn-outline {\r\n  /* Deprecated in new design but kept for reference if needed */\r\n  padding: 0.75rem 1.75rem;\r\n  background: transparent;\r\n  color: var(--text-main);\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  border-radius: 12px;\r\n  font-weight: 600;\r\n  font-size: 0.95rem;\r\n  cursor: pointer;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  backdrop-filter: blur(5px);\r\n}\r\n\r\n/* Hero Section */\r\n.hero-section {\r\n  padding: 130px 5% 60px;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.hero-content {\r\n  max-width: 1400px;\r\n  margin: 0 auto;\r\n  display: grid;\r\n  grid-template-columns: 40% 60%;\r\n  gap: 2.5rem;\r\n  align-items: flex-start;\r\n}\r\n\r\n.hero-visual {\r\n  width: 100%;\r\n  min-width: 0;\r\n}\r\n\r\n.hero-text {\r\n  text-align: left;\r\n  min-width: 0;\r\n}\r\n\r\n.hero-title {\r\n  font-family: 'Outfit', sans-serif;\r\n  font-size: 4rem;\r\n  font-weight: 800;\r\n  line-height: 1.1;\r\n  margin-bottom: 1.5rem;\r\n  letter-spacing: -0.03em;\r\n}\r\n\r\n.gradient-text {\r\n  background: var(--gradient-main);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n  display: inline-block;\r\n  padding-bottom: 10px;\r\n  /* Prevent descender clipping */\r\n}\r\n\r\n.hero-subtitle {\r\n  font-size: 1.25rem;\r\n  color: var(--text-muted);\r\n  margin-bottom: 3rem;\r\n  line-height: 1.7;\r\n  max-width: 90%;\r\n  font-weight: 400;\r\n}\r\n\r\n.hero-checklist {\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  gap: 1rem;\r\n  margin-bottom: 3.5rem;\r\n  align-items: center;\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n  .hero-checklist {\r\n    flex-wrap: wrap;\r\n    gap: 1.25rem;\r\n  }\r\n}\r\n\r\n.checklist-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  font-family: 'Outfit', sans-serif;\r\n  font-size: 0.92rem;\r\n  font-weight: 600;\r\n  color: var(--text-main);\r\n  opacity: 0.85;\r\n  transition: all 0.3s ease;\r\n  white-space: nowrap;\r\n}\r\n\r\n.checklist-item:hover {\r\n  opacity: 1;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.checklist-icon {\r\n  color: #d946ef; /* Magenta/Purple check icon color from screenshot */\r\n  flex-shrink: 0;\r\n  filter: drop-shadow(0 0 5px rgba(217, 70, 239, 0.45));\r\n}\r\n\r\n.hero-actions {\r\n  display: flex;\r\n  gap: 1.5rem;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.btn-primary-large {\r\n  position: relative;\r\n  padding: 1.25rem 3rem;\r\n  background: var(--gradient-main);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 16px;\r\n  font-size: 1.125rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\r\n  box-shadow: 0 0 20px rgba(99, 102, 241, 0.4);\r\n  overflow: hidden;\r\n  z-index: 1;\r\n}\r\n\r\n.btn-primary-large::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.3), transparent);\r\n  transform: translateX(-100%);\r\n  transition: transform 0.6s ease;\r\n  z-index: -1;\r\n}\r\n\r\n.btn-primary-large:hover {\r\n  transform: translateY(-4px) scale(1.02);\r\n  box-shadow: 0 0 40px rgba(168, 85, 247, 0.6);\r\n}\r\n\r\n.btn-primary-large:hover::before {\r\n  transform: translateX(100%);\r\n}\r\n\r\n/* Target Platforms Panel */\r\n.target-platforms-panel {\r\n  background: rgba(10, 14, 35, 0.6);\r\n  backdrop-filter: blur(24px);\r\n  -webkit-backdrop-filter: blur(24px);\r\n  border-radius: 24px;\r\n  border: 1.5px solid rgba(99, 102, 241, 0.25);\r\n  box-shadow:\r\n    0 40px 80px -20px rgba(0, 0, 0, 0.7),\r\n    0 0 40px rgba(99, 102, 241, 0.12),\r\n    inset 0 1px 0 rgba(255, 255, 255, 0.06);\r\n  padding: 1.75rem;\r\n  transform: rotateY(-8deg) rotateX(4deg);\r\n  transform-style: preserve-3d;\r\n  transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.6s ease;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.target-platforms-panel::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0; left: 0; right: 0;\r\n  height: 1px;\r\n  background: linear-gradient(90deg, transparent, rgba(168, 85, 247, 0.4), transparent);\r\n}\r\n\r\n.target-platforms-panel:hover {\r\n  transform: rotateY(0deg) rotateX(0deg) scale(1.02);\r\n  box-shadow:\r\n    0 50px 100px -20px rgba(0, 0, 0, 0.8),\r\n    0 0 60px rgba(168, 85, 247, 0.18),\r\n    inset 0 1px 0 rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.tp-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 1.5rem;\r\n  padding-bottom: 1rem;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\r\n}\r\n\r\n.tp-title {\r\n  font-family: 'Outfit', sans-serif;\r\n  font-size: 1.05rem;\r\n  font-weight: 700;\r\n  color: var(--text-main);\r\n  letter-spacing: 0.01em;\r\n}\r\n\r\n.tp-live-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 3px 10px;\r\n  background: rgba(16, 185, 129, 0.12);\r\n  border: 1px solid rgba(16, 185, 129, 0.25);\r\n  border-radius: 20px;\r\n  font-size: 0.7rem;\r\n  font-weight: 700;\r\n  color: #34d399;\r\n  letter-spacing: 0.5px;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.tp-live-dot {\r\n  width: 6px;\r\n  height: 6px;\r\n  border-radius: 50%;\r\n  background: #34d399;\r\n  box-shadow: 0 0 6px #34d399;\r\n  animation: tpLivePulse 2s ease infinite;\r\n}\r\n\r\n@keyframes tpLivePulse {\r\n  0%, 100% { opacity: 1; transform: scale(1); }\r\n  50%       { opacity: 0.5; transform: scale(0.8); }\r\n}\r\n\r\n.tp-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.tp-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  padding: 0.85rem 1rem;\r\n  background: rgba(255, 255, 255, 0.03);\r\n  border: 1px solid rgba(255, 255, 255, 0.06);\r\n  border-radius: 14px;\r\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\r\n  cursor: default;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.tp-item::before {\r\n  content: '';\r\n  position: absolute;\r\n  left: 0; top: 0; bottom: 0;\r\n  width: 3px;\r\n  border-radius: 3px 0 0 3px;\r\n  background: var(--gradient-main);\r\n  opacity: 0;\r\n  transition: opacity 0.3s ease;\r\n}\r\n\r\n.tp-item:hover {\r\n  background: rgba(99, 102, 241, 0.07);\r\n  border-color: rgba(99, 102, 241, 0.2);\r\n  transform: translateX(4px);\r\n}\r\n\r\n.tp-item:hover::before {\r\n  opacity: 1;\r\n}\r\n\r\n.tp-item--soon {\r\n  opacity: 0.55;\r\n}\r\n\r\n.tp-item--soon:hover {\r\n  opacity: 0.75;\r\n}\r\n\r\n.tp-item-icon {\r\n  width: 42px;\r\n  height: 42px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: rgba(255, 255, 255, 0.05);\r\n  border-radius: 10px;\r\n  border: 1px solid rgba(255, 255, 255, 0.07);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.tp-item-icon--plain {\r\n  background: rgba(99, 102, 241, 0.08);\r\n  border-color: rgba(99, 102, 241, 0.15);\r\n}\r\n\r\n.tp-logo {\r\n  width: 26px;\r\n  height: 26px;\r\n  object-fit: contain;\r\n}\r\n\r\n.aws-logo-theme-fix {\r\n  filter: invert(1) hue-rotate(180deg) brightness(1.3) opacity(0.85);\r\n}\r\n\r\n.tp-item-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.tp-item-name {\r\n  font-size: 0.88rem;\r\n  font-weight: 600;\r\n  color: var(--text-main);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.tp-item-tag {\r\n  font-size: 0.7rem;\r\n  font-weight: 500;\r\n  color: var(--text-muted);\r\n  letter-spacing: 0.3px;\r\n}\r\n\r\n.tp-item-status {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  padding: 3px 10px;\r\n  border-radius: 20px;\r\n  font-size: 0.7rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.3px;\r\n  flex-shrink: 0;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.tp-status--active {\r\n  background: rgba(16, 185, 129, 0.12);\r\n  border: 1px solid rgba(16, 185, 129, 0.22);\r\n  color: #34d399;\r\n}\r\n\r\n.tp-status--active .tp-status-dot {\r\n  width: 5px;\r\n  height: 5px;\r\n  border-radius: 50%;\r\n  background: #34d399;\r\n  box-shadow: 0 0 5px #34d399;\r\n  animation: tpLivePulse 2s ease infinite;\r\n}\r\n\r\n.tp-status--soon {\r\n  background: rgba(245, 158, 11, 0.1);\r\n  border: 1px solid rgba(245, 158, 11, 0.2);\r\n  color: #f59e0b;\r\n}\r\n\r\n.tp-status--soon .tp-status-dot {\r\n  width: 5px;\r\n  height: 5px;\r\n  border-radius: 50%;\r\n  background: #f59e0b;\r\n}\r\n\r\n.tp-footer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-around;\r\n  margin-top: 1.5rem;\r\n  padding-top: 1rem;\r\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\r\n}\r\n\r\n.tp-stat {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 2px;\r\n}\r\n\r\n.tp-stat-val {\r\n  font-family: 'Outfit', sans-serif;\r\n  font-size: 1.1rem;\r\n  font-weight: 800;\r\n  background: var(--gradient-main);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n}\r\n\r\n.tp-stat-label {\r\n  font-size: 0.65rem;\r\n  color: var(--text-muted);\r\n  font-weight: 500;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.tp-stat-divider {\r\n  width: 1px;\r\n  height: 28px;\r\n  background: rgba(255, 255, 255, 0.07);\r\n}\r\n\r\n/* Dashboard Preview (3D Effect) */\r\n.hero-visual {\r\n  perspective: 2000px;\r\n  z-index: 2;\r\n}\r\n\r\n.dashboard-preview {\r\n  background: rgba(15, 22, 42, 0.4) !important;\r\n  backdrop-filter: var(--glass-blur);\r\n  border-radius: 24px;\r\n  border: 1.5px solid rgba(99, 102, 241, 0.25) !important;\r\n  box-shadow:\r\n    0 50px 100px -20px rgba(0, 0, 0, 0.8),\r\n    0 0 40px rgba(99, 102, 241, 0.15),\r\n    var(--glass-inner-glow);\r\n  padding: 2rem;\r\n  transform-style: preserve-3d;\r\n  transform: rotateY(-12deg) rotateX(6deg);\r\n  transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.6s ease;\r\n  position: relative;\r\n}\r\n\r\n.dashboard-preview:hover {\r\n  transform: rotateY(0deg) rotateX(0deg) scale(1.02);\r\n  box-shadow:\r\n    0 60px 120px -20px rgba(0, 0, 0, 0.85),\r\n    0 0 60px rgba(168, 85, 247, 0.2),\r\n    var(--glass-inner-glow);\r\n}\r\n\r\n/* Glass Details inside Dashboard */\r\n.preview-header {\r\n  display: flex;\r\n  margin-bottom: 2rem;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\r\n  padding-bottom: 1.5rem;\r\n}\r\n\r\n.preview-tabs {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  background: rgba(255, 255, 255, 0.03);\r\n  padding: 0.5rem;\r\n  border-radius: 12px;\r\n}\r\n\r\n.tab {\r\n  padding: 0.6rem 1.2rem;\r\n  border-radius: 8px;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n  color: var(--text-muted);\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.tab.active {\r\n  background: var(--surface-light);\r\n  color: var(--text-main);\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.preview-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.5rem;\r\n}\r\n\r\n.preview-card {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1.25rem;\r\n  padding: 1.25rem;\r\n  background: rgba(255, 255, 255, 0.03) !important;\r\n  border: var(--glass-border) !important;\r\n  border-radius: 16px;\r\n  box-shadow: var(--glass-inner-glow);\r\n}\r\n\r\n.card-icon {\r\n  width: 48px;\r\n  height: 48px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: rgba(99, 102, 241, 0.1);\r\n  border-radius: 12px;\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.card-info h4 {\r\n  font-family: 'Outfit', sans-serif;\r\n  color: var(--text-main);\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.card-status {\r\n  margin-left: auto;\r\n  padding: 0.4rem 1rem;\r\n  background: rgba(16, 185, 129, 0.2);\r\n  color: #34d399;\r\n  border: 1px solid rgba(16, 185, 129, 0.2);\r\n  border-radius: 30px;\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.migration-progress {\r\n  padding: 1.5rem;\r\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.1) 0%, rgba(168, 85, 247, 0.1) 100%);\r\n  border: 1px solid rgba(99, 102, 241, 0.2);\r\n  border-radius: 16px;\r\n}\r\n\r\n.progress-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-bottom: 1rem;\r\n  font-weight: 600;\r\n  color: var(--text-main);\r\n}\r\n\r\n.progress-bar {\r\n  height: 8px;\r\n  background: rgba(255, 255, 255, 0.1);\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n}\r\n\r\n.progress-fill {\r\n  height: 100%;\r\n  background: var(--gradient-main);\r\n  border-radius: 4px;\r\n  filter: drop-shadow(0 0 8px rgba(168, 85, 247, 0.5));\r\n}\r\n\r\n/* CTA Section */\r\n.cta-section {\r\n  padding: 120px 5%;\r\n  text-align: center;\r\n  position: relative;\r\n  z-index: 1;\r\n  background: linear-gradient(to bottom, transparent, rgba(99, 102, 241, 0.05));\r\n}\r\n\r\n.cta-section h2 {\r\n  font-size: 3rem;\r\n  font-family: 'Outfit', sans-serif;\r\n  margin-bottom: 3rem;\r\n  background: var(--gradient-heading);\r\n  -webkit-background-clip: text;\r\n  background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n}\r\n\r\n/* Footer */\r\n.footer {\r\n  padding: 50px 140px 30px; /* Reduced vertical padding from 80px/40px to 50px/30px */\r\n  background: rgba(2, 6, 23, 0.75); /* Dark solid-glass overlay to shield the text */\r\n  backdrop-filter: blur(20px); /* Deep blur to soften background light trails */\r\n  -webkit-backdrop-filter: blur(20px);\r\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\r\n  position: relative;\r\n  z-index: 10; /* Ensure it stays on top of the animation canvas */\r\n}\r\n\r\n.footer-content {\r\n  display: grid;\r\n  grid-template-columns: 1fr auto 1fr; /* Symmetrical 3-column grid */\r\n  align-items: center;\r\n  max-width: 1200px;\r\n  margin: 0 auto 1.5rem; /* Reduced bottom margin from 3rem to 1.5rem */\r\n  gap: 0;\r\n}\r\n\r\n.footer-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1.5rem;\r\n  padding-right: 3rem; /* Space before divider */\r\n}\r\n\r\n.footer-desc {\r\n  font-size: 0.85rem;\r\n  color: rgba(255, 255, 255, 0.7);\r\n  line-height: 1.5;\r\n  margin: 0;\r\n  max-width: 380px;\r\n  text-align: left;\r\n}\r\n\r\n.footer-divider {\r\n  width: 1px;\r\n  height: 60px;\r\n  background: rgba(255, 255, 255, 0.1);\r\n  align-self: center;\r\n}\r\n\r\n.footer-right {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 0.3rem;\r\n  padding-left: 3rem; /* Space after divider */\r\n}\r\n\r\n.footer-title {\r\n  font-size: 0.85rem;\r\n  font-weight: 700;\r\n  color: #f59e0b;\r\n  letter-spacing: 0.05em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.footer-link-text {\r\n  font-size: 0.85rem;\r\n  color: rgba(255, 255, 255, 0.7);\r\n  margin: 0;\r\n  text-align: left;\r\n  line-height: 1.5;\r\n}\r\n\r\n.footer-link-text a {\r\n  color: #f59e0b;\r\n  text-decoration: none;\r\n  font-weight: 600;\r\n  transition: opacity 0.2s;\r\n}\r\n\r\n.footer-link-text a:hover {\r\n  opacity: 0.8;\r\n}\r\n\r\n.footer-bottom {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding-top: 1.25rem; /* Reduced padding-top from 2rem to 1.25rem */\r\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\r\n  color: rgba(255, 255, 255, 0.4);\r\n  font-size: 0.9rem;\r\n  gap: 0.85rem; /* Reduced gap from 1.25rem to 0.85rem */\r\n}\r\n\r\n.footer-copyright {\r\n  text-align: center;\r\n  margin: 0;\r\n  white-space: nowrap; /* Keep it on a single line on desktop */\r\n}\r\n\r\n.scroll-to-top-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 44px;\r\n  height: 44px;\r\n  border-radius: 50%;\r\n  border: 1px solid rgba(59, 130, 246, 0.3); /* Blueish border */\r\n  background: rgba(13, 35, 73, 0.4); /* Dark blueish glassy background */\r\n  backdrop-filter: blur(8px); /* Glassy blur */\r\n  -webkit-backdrop-filter: blur(8px);\r\n  color: #60a5fa; /* Light blue arrow */\r\n  cursor: pointer;\r\n  font-size: 1.25rem;\r\n  line-height: 1;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  outline: none;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), inset 0 1px 1px rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.scroll-to-top-btn:hover {\r\n  border-color: rgba(59, 130, 246, 0.6);\r\n  color: #fff;\r\n  background: rgba(59, 130, 246, 0.25); /* Vibrant blue glass hover */\r\n  box-shadow: 0 0 15px rgba(59, 130, 246, 0.4), inset 0 1px 1px rgba(255, 255, 255, 0.2);\r\n  transform: translateY(-3px); /* Subtle lift */\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 1024px) {\r\n  .hero-content {\r\n    grid-template-columns: 1fr;\r\n    text-align: center;\r\n    gap: 4rem;\r\n  }\r\n\r\n  .hero-text {\r\n    text-align: center;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n\r\n  .dashboard-preview {\r\n    transform: none;\r\n    /* Disable 3D tilt on tablet/mobile for readability */\r\n  }\r\n\r\n  .dashboard-preview:hover {\r\n    transform: scale(1.02);\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .hero-title {\r\n    font-size: 3rem;\r\n  }\r\n\r\n  .hero-checklist {\r\n    gap: 1.25rem;\r\n    justify-content: flex-start;\r\n  }\r\n\r\n  .footer-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 2rem;\r\n  }\r\n\r\n  .footer-left {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 1rem;\r\n    width: 100%;\r\n    padding-right: 0; /* Reset desktop padding */\r\n  }\r\n\r\n  .footer-desc {\r\n    max-width: 100%;\r\n  }\r\n\r\n  .footer-divider {\r\n    display: none;\r\n  }\r\n\r\n  .footer-right {\r\n    padding-left: 0; /* Reset desktop padding */\r\n    border-left: none;\r\n    width: 100%;\r\n  }\r\n\r\n  .footer-bottom {\r\n    display: flex;\r\n    flex-direction: column-reverse;\r\n    gap: 1.5rem;\r\n    align-items: center;\r\n    text-align: center;\r\n    width: 100%;\r\n  }\r\n\r\n  .footer-bottom-spacer {\r\n    display: none;\r\n  }\r\n\r\n  .footer-copyright {\r\n    text-align: center;\r\n    width: 100%;\r\n    white-space: normal; /* Allow text wrap on mobile */\r\n  }\r\n\r\n  .footer-scroll-wrapper {\r\n    justify-content: center;\r\n    width: 100%;\r\n  }\r\n\r\n  .footer-link-text {\r\n    white-space: normal; /* Allow wrap on mobile */\r\n  }\r\n}\r\n\r\n/* ──────────────────────────────────────\r\n   NEW SAAS LANDING PAGE BODY SECTIONS\r\n   ────────────────────────────────────── */\r\n\r\n.landing-section {\r\n  padding: 110px 5%;\r\n  position: relative;\r\n  z-index: 1;\r\n  max-width: 1300px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.badge-pill-feature {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 6px 14px;\r\n  background: rgba(168, 85, 247, 0.08);\r\n  border: 1px solid rgba(168, 85, 247, 0.22);\r\n  border-radius: 30px;\r\n  color: #c084fc;\r\n  font-family: 'Outfit', sans-serif;\r\n  font-size: 0.8rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 1.2px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.section-header-left {\r\n  text-align: left;\r\n  margin-bottom: 60px;\r\n  max-width: 800px;\r\n}\r\n\r\n.section-header-center {\r\n  text-align: center;\r\n  margin-bottom: 60px;\r\n  max-width: 750px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.section-main-title {\r\n  font-family: 'Outfit', sans-serif;\r\n  font-size: 2.75rem;\r\n  font-weight: 800;\r\n  color: var(--text-main);\r\n  line-height: 1.15;\r\n  letter-spacing: -0.02em;\r\n}\r\n\r\n.section-sub-desc {\r\n  color: var(--text-muted);\r\n  font-size: 1.125rem;\r\n  line-height: 1.6;\r\n  margin-top: 15px;\r\n}\r\n\r\n.db-preview-panel {\r\n  background: rgba(5, 8, 26, 0.92);\r\n  border: 1px solid rgba(99, 102, 241, 0.25);\r\n  border-radius: 20px;\r\n  padding: 1.6rem 1.8rem;\r\n  backdrop-filter: blur(20px);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.2rem;\r\n  box-shadow: 0 8px 40px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.06);\r\n}\r\n\r\n.db-preview-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 0.8rem;\r\n}\r\n\r\n.db-preview-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  font-family: 'Outfit', sans-serif;\r\n  font-size: 0.92rem;\r\n  font-weight: 700;\r\n  color: rgba(255,255,255,0.92);\r\n}\r\n\r\n.db-live-dot {\r\n  display: inline-block;\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background: #34d399;\r\n  box-shadow: 0 0 8px #34d399;\r\n  animation: db-pulse 1.5s ease-in-out infinite;\r\n  flex-shrink: 0;\r\n}\r\n\r\n@keyframes db-pulse {\r\n  0%, 100% { opacity: 1; transform: scale(1); }\r\n  50% { opacity: 0.55; transform: scale(0.85); }\r\n}\r\n\r\n.db-preview-badge {\r\n  font-family: 'Outfit', sans-serif;\r\n  font-size: 0.68rem;\r\n  font-weight: 600;\r\n  color: rgba(168,85,247,0.85);\r\n  background: rgba(168,85,247,0.1);\r\n  border: 1px solid rgba(168,85,247,0.25);\r\n  border-radius: 20px;\r\n  padding: 0.22rem 0.65rem;\r\n  white-space: nowrap;\r\n}\r\n\r\n.db-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.4rem;\r\n}\r\n\r\n.db-label {\r\n  font-family: 'Outfit', sans-serif;\r\n  font-size: 0.7rem;\r\n  font-weight: 600;\r\n  letter-spacing: 0.07em;\r\n  text-transform: uppercase;\r\n  color: rgba(255,255,255,0.35);\r\n}\r\n\r\n.db-progress-meta {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.db-progress-pct {\r\n  font-family: 'Outfit', sans-serif;\r\n  font-size: 0.88rem;\r\n  font-weight: 700;\r\n  color: #a78bfa;\r\n}\r\n\r\n.db-progress-track {\r\n  height: 7px;\r\n  background: rgba(255,255,255,0.07);\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n}\r\n\r\n.db-progress-fill {\r\n  height: 100%;\r\n  border-radius: 6px;\r\n  background: linear-gradient(90deg, #7c3aed, #a855f7, #c084fc);\r\n  box-shadow: 0 0 10px rgba(168,85,247,0.5);\r\n  transition: width 0.15s linear;\r\n}\r\n\r\n.db-progress-sub {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  font-family: 'Outfit', sans-serif;\r\n  font-size: 0.68rem;\r\n  color: rgba(255,255,255,0.35);\r\n  margin-top: 0.15rem;\r\n}\r\n\r\n.db-stats-row {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 0.7rem;\r\n}\r\n\r\n.db-stat-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.25rem;\r\n  background: rgba(255,255,255,0.03);\r\n  border: 1px solid rgba(255,255,255,0.07);\r\n  border-radius: 10px;\r\n  padding: 0.6rem 0.4rem;\r\n  text-align: center;\r\n}\r\n\r\n.db-stat-value {\r\n  font-family: 'Outfit', sans-serif;\r\n  font-size: 0.88rem;\r\n  font-weight: 800;\r\n  line-height: 1;\r\n  letter-spacing: -0.01em;\r\n}\r\n\r\n.db-stat-label {\r\n  font-family: 'Outfit', sans-serif;\r\n  font-size: 0.62rem;\r\n  font-weight: 500;\r\n  color: rgba(255,255,255,0.35);\r\n  text-align: center;\r\n}\r\n\r\n.db-chart-container {\r\n  width: 100%;\r\n  height: 80px;\r\n  background: rgba(255, 255, 255, 0.02);\r\n  border: 1px solid rgba(255, 255, 255, 0.05);\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  margin-top: 0.2rem;\r\n}\r\n\r\n.db-preview-footer {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  font-family: 'Outfit', sans-serif;\r\n  font-size: 0.7rem;\r\n  color: rgba(255,255,255,0.3);\r\n  border-top: 1px solid rgba(255,255,255,0.06);\r\n  padding-top: 0.8rem;\r\n  margin-top: 0.2rem;\r\n}\r\n\r\n.db-footer-dot {\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 50%;\r\n  flex-shrink: 0;\r\n  animation: db-pulse 1.5s ease-in-out infinite;\r\n}\r\n\r\n\r\n/* Compare Grid Section */\r\n.compare-section-grid {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 2.5rem;\r\n}\r\n\r\n\r\n.compare-card {\r\n  position: relative;\r\n  height: 285px;\r\n  padding: 2.2rem;\r\n  background: var(--card-bg);\r\n  border: var(--glass-border);\r\n  border-radius: 24px;\r\n  backdrop-filter: var(--glass-blur);\r\n  box-shadow: var(--glass-shadow);\r\n  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.compare-card.large-card {\r\n  grid-column: span 2;\r\n}\r\n\r\n.compare-card:hover {\r\n  background: rgba(20, 24, 48, 0.65);\r\n  transform: translateY(-6px);\r\n  border-color: rgba(168, 85, 247, 0.45);\r\n  box-shadow: 0 0 35px rgba(168, 85, 247, 0.2),\r\n              inset 0 0 18px rgba(168, 85, 247, 0.15),\r\n              var(--glass-shadow);\r\n}\r\n\r\n.compare-card .compare-card-top {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.75rem;\r\n  opacity: 1;\r\n  transform: scale(1);\r\n  transition: opacity 0.4s cubic-bezier(0.16, 1, 0.3, 1),\r\n              transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);\r\n}\r\n\r\n.compare-card:hover .compare-card-top {\r\n  opacity: 0;\r\n  transform: scale(0.96);\r\n  pointer-events: none;\r\n}\r\n\r\n.compare-card .icon-wrap {\r\n  width: 48px;\r\n  height: 48px;\r\n  border-radius: 12px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: rgba(168, 85, 247, 0.12);\r\n  color: #a855f7;\r\n}\r\n\r\n.compare-card h3 {\r\n  font-family: 'Outfit', sans-serif;\r\n  font-size: 1.35rem;\r\n  font-weight: 700;\r\n  color: var(--text-main);\r\n  letter-spacing: -0.01em;\r\n}\r\n\r\n.compare-card p {\r\n  font-size: 0.95rem;\r\n  color: var(--text-muted);\r\n  line-height: 1.6;\r\n}\r\n\r\n.large-card-banner {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  margin: 0;\r\n  width: auto;\r\n  height: auto;\r\n  opacity: 0;\r\n  transform: scale(0.96);\r\n  pointer-events: none;\r\n  background: rgba(15, 23, 42, 0.7);\r\n  border: 1px solid rgba(255, 255, 255, 0.08);\r\n  border-radius: 24px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  overflow: hidden;\r\n  box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.05), 0 8px 32px rgba(0, 0, 0, 0.4);\r\n  backdrop-filter: blur(16px);\r\n  -webkit-backdrop-filter: blur(16px);\r\n  transition: opacity 0.4s cubic-bezier(0.16, 1, 0.3, 1),\r\n              transform 0.4s cubic-bezier(0.16, 1, 0.3, 1),\r\n              border-color 0.4s ease;\r\n}\r\n\r\n.card-diagram-banner {\r\n  position: absolute;\r\n  top: 1.8rem;\r\n  left: 1.8rem;\r\n  right: 1.8rem;\r\n  bottom: 1.8rem;\r\n  margin: 0;\r\n  width: auto;\r\n  height: auto;\r\n  opacity: 0;\r\n  transform: scale(0.96);\r\n  pointer-events: none;\r\n  background: rgba(15, 23, 42, 0.55);\r\n  border: 1px solid rgba(255, 255, 255, 0.05);\r\n  border-radius: 16px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  overflow: hidden;\r\n  box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.05), 0 8px 32px rgba(0, 0, 0, 0.4);\r\n  backdrop-filter: blur(16px);\r\n  -webkit-backdrop-filter: blur(16px);\r\n  transition: opacity 0.4s cubic-bezier(0.16, 1, 0.3, 1),\r\n              transform 0.4s cubic-bezier(0.16, 1, 0.3, 1),\r\n              border-color 0.4s ease;\r\n}\r\n\r\n.compare-card:hover .large-card-banner,\r\n.compare-card:hover .card-diagram-banner {\r\n  opacity: 1;\r\n  transform: scale(1);\r\n  pointer-events: auto;\r\n  border-color: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n/* Split Layout Section */\r\n.split-layout-section {\r\n  display: grid;\r\n  grid-template-columns: 1.1fr 0.9fr;\r\n  gap: 4rem;\r\n  align-items: center;\r\n}\r\n\r\n.split-left-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n}\r\n\r\n.split-left-content .section-main-title {\r\n  margin-top: 10px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.split-left-content p {\r\n  color: var(--text-muted);\r\n  font-size: 1.1rem;\r\n  line-height: 1.65;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.mini-cards-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 1.25rem;\r\n  margin-bottom: 2rem;\r\n  width: 100%;\r\n}\r\n\r\n.mini-card {\r\n  padding: 0.8rem 1rem;\r\n  background: var(--card-bg);\r\n  border: var(--glass-border);\r\n  border-radius: 16px;\r\n  backdrop-filter: var(--glass-blur);\r\n  box-shadow: var(--glass-shadow);\r\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\r\n}\r\n\r\n.mini-card .border-glow-inner {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.mini-card:hover {\r\n  border-color: rgba(99, 102, 241, 0.3);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.mini-card .mini-icon {\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: rgba(99, 102, 241, 0.15);\r\n  color: #6366f1;\r\n}\r\n\r\n.mini-card span {\r\n  font-weight: 700;\r\n  font-size: 0.9rem;\r\n  color: var(--text-main);\r\n  letter-spacing: -0.1px;\r\n}\r\n\r\n/* Status list card */\r\n.status-list-card {\r\n  padding: 1.5rem;\r\n  background: var(--card-bg);\r\n  border: var(--glass-border);\r\n  border-radius: 20px;\r\n  backdrop-filter: var(--glass-blur);\r\n  box-shadow: var(--glass-shadow);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n  width: 100%;\r\n}\r\n\r\n.status-list-title {\r\n  font-size: 0.775rem;\r\n  font-weight: 700;\r\n  color: var(--text-muted);\r\n  text-transform: uppercase;\r\n  letter-spacing: 1px;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\r\n  padding-bottom: 10px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.status-list-title .live-dot {\r\n  width: 6px;\r\n  height: 6px;\r\n  border-radius: 50%;\r\n  background: #10b981;\r\n  box-shadow: 0 0 8px #10b981;\r\n  animation: livePulse 2s infinite;\r\n}\r\n\r\n@keyframes livePulse {\r\n  0%, 100% { opacity: 0.3; }\r\n  50% { opacity: 1; }\r\n}\r\n\r\n.status-item {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px 0;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.03);\r\n}\r\n\r\n.status-item:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.status-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.status-db-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.status-db-name {\r\n  font-weight: 700;\r\n  font-size: 0.9rem;\r\n  color: var(--text-main);\r\n}\r\n\r\n.status-route {\r\n  font-size: 0.75rem;\r\n  color: var(--text-muted);\r\n  margin-top: 2px;\r\n}\r\n\r\n.status-right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 15px;\r\n}\r\n\r\n.status-badge {\r\n  font-size: 0.7rem;\r\n  font-weight: 700;\r\n  padding: 2px 8px;\r\n  border-radius: 10px;\r\n}\r\n\r\n.status-badge.active {\r\n  color: #10b981;\r\n  background: rgba(16, 185, 129, 0.1);\r\n  border: 1px solid rgba(16, 185, 129, 0.2);\r\n}\r\n\r\n.status-badge.soon {\r\n  color: #a855f7;\r\n  background: rgba(168, 85, 247, 0.1);\r\n  border: 1px solid rgba(168, 85, 247, 0.2);\r\n}\r\n\r\n.status-perf {\r\n  font-size: 0.8rem;\r\n  color: #22d3ee;\r\n  font-weight: 600;\r\n  font-family: monospace;\r\n}\r\n\r\n/* Timeline workflow */\r\n.timeline-container {\r\n  max-width: 850px;\r\n  margin: 0 auto;\r\n  position: relative;\r\n  padding-left: 45px;\r\n}\r\n\r\n.timeline-line {\r\n  position: absolute;\r\n  left: 15px;\r\n  top: 20px;\r\n  bottom: 20px;\r\n  width: 2px;\r\n  background: linear-gradient(to bottom, #7c3aed 0%, #3b82f6 50%, #06b6d4 100%);\r\n  opacity: 0.35;\r\n}\r\n\r\n.timeline-item {\r\n  position: relative;\r\n  margin-bottom: 3rem;\r\n}\r\n\r\n.timeline-item:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.timeline-dot {\r\n  position: absolute;\r\n  left: -45px;\r\n  top: 12px;\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 50%;\r\n  background: #07091e;\r\n  border: 2px solid #7c3aed;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  box-shadow: 0 0 15px rgba(124, 58, 237, 0.4);\r\n  z-index: 2;\r\n  transition: all 0.3s ease;\r\n  color: #a855f7;\r\n}\r\n\r\n.timeline-item:hover .timeline-dot {\r\n  background: #7c3aed;\r\n  color: white !important;\r\n  transform: scale(1.1);\r\n}\r\n\r\n.timeline-card {\r\n  padding: 2rem 2.25rem;\r\n  background: var(--card-bg);\r\n  border: var(--glass-border);\r\n  border-radius: 20px;\r\n  backdrop-filter: var(--glass-blur);\r\n  box-shadow: var(--glass-shadow);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\r\n}\r\n\r\n.timeline-card:hover {\r\n  border-color: rgba(99, 102, 241, 0.3);\r\n  box-shadow: 0 10px 30px rgba(99, 102, 241, 0.05), var(--glass-shadow);\r\n}\r\n\r\n.timeline-step-badge {\r\n  align-self: flex-start;\r\n  font-size: 0.725rem;\r\n  font-weight: 700;\r\n  color: #a855f7;\r\n  text-transform: uppercase;\r\n  letter-spacing: 1.2px;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.timeline-card h3 {\r\n  font-family: 'Outfit', sans-serif;\r\n  font-size: 1.35rem;\r\n  font-weight: 700;\r\n  color: var(--text-main);\r\n  letter-spacing: -0.01em;\r\n}\r\n\r\n.timeline-card p {\r\n  font-size: 0.95rem;\r\n  color: var(--text-muted);\r\n  line-height: 1.65;\r\n}\r\n\r\n/* Responsive adjustment for split layouts */\r\n@media (max-width: 1024px) {\r\n  .compare-section-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  .compare-card.large-card {\r\n    grid-row: span 1;\r\n  }\r\n  .split-layout-section {\r\n    grid-template-columns: 1fr;\r\n    gap: 3rem;\r\n  }\r\n}\r"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
